module.exports = __webpack_public_path__ + "static/media/home_back_svg.84a30345.svg";